import { render, staticRenderFns } from "./AdminMailingLists.vue?vue&type=template&id=cf7e4fdc&scoped=true"
import script from "./AdminMailingLists.vue?vue&type=script&lang=js"
export * from "./AdminMailingLists.vue?vue&type=script&lang=js"
import style0 from "./AdminMailingLists.vue?vue&type=style&index=0&id=cf7e4fdc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf7e4fdc",
  null
  
)

export default component.exports